import { render, staticRenderFns } from "./Blackouts.vue?vue&type=template&id=87b62d8a&"
import script from "./Blackouts.vue?vue&type=script&lang=ts&"
export * from "./Blackouts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports